import React, { useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { LiveService } from '../services/live-service';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function DeleteLiveTagModal({ id, onUpdate }) {

    const [open, setOpen] = useState(true);
    //const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    async function deleteTag(id) {

        try {
            let resObject = await LiveService.deleteTag(id);
            let res = { status: resObject.status, };

            if (!res || res.status !== 204) {
                console.log(`Error deleteTag: `, res.status);
                handleClose();
                onUpdate(false);

                return {
                    revalidate: 5,
                    notFound: true,
                }
            }

            console.log(`Result of Delete tag: OK!`);
            handleClose();
            onUpdate(true);
        } catch (e) {
            console.log(e);
            return {
                revalidate: 5,
                notFound: true,
            }
        }
    }

    return (
        <div>
            {/* <Button onClick={handleOpen}>Open modal</Button> */}
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <h5>Elimina il Tag</h5>
                        <hr />
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            Vuoi eliminare il tag ID {id}?
                        </Typography>
                        <hr />
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-6 col-xl-6">
                                <button type="button" className="btn btn-primary"
                                    style={{ minWidth: '6rem', marginLeft: '10px', float: "left" }}
                                    onClick={() => { onUpdate(null); handleClose(); }}>
                                    Annulla
                                </button>
                            </div>
                            <div className="col-12 col-md-12 col-lg-6 col-xl-6">
                                <button type="button" className="btn btn-success"
                                    style={{ minWidth: '6rem', marginRight: '10px', float: "right" }}
                                    onClick={() => { deleteTag(id) }}>
                                    Conferma
                                </button>
                            </div>
                        </div>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}